import { ActionTree, GetterTree, MutationTree } from 'vuex'
import { getAchieveState } from '@/api/achieve'
import {
    IAchieveGoalData,
    IAchieveLevelData,
    IGoalProgress,
} from '@/entities/achieve'

export interface AchieveState {
    achieveLoading: boolean
    achieveLevelData: IAchieveLevelData | null
    goalData: IAchieveGoalData | null
    goalProgress: IGoalProgress | null
}

export const state: AchieveState = {
    achieveLoading: false,
    achieveLevelData: null,
    goalData: null,
    goalProgress: null,
}

const getters: GetterTree<AchieveState, any> = {
    achieveLoading({ achieveLoading }) {
        return achieveLoading
    },
    achieveLevelData({ achieveLevelData }) {
        return achieveLevelData
    },
    goalData({ goalData }) {
        return goalData
    },
    goalProgress({ goalProgress }) {
        return goalProgress
    },
}

const actions: ActionTree<AchieveState, any> = {
    async loadAchieveData({ commit }) {
        commit('setAchieveLoading', true)

        try {
            const { data } = await getAchieveState()
            commit('setLevelData', data.currentAchieveLevel)
            commit('setGoalData', data.goals)
            commit('setGoalProgress', data.progress)
        } catch (e) {
            return null
        }

        commit('setAchieveLoading', false)
    },
}

const mutations: MutationTree<AchieveState> = {
    setAchieveLoading(state, achieveLoading: boolean) {
        state.achieveLoading = achieveLoading
    },
    setLevelData(state, achieveLevelData) {
        state.achieveLevelData = achieveLevelData
    },
    setGoalData(state, goalData) {
        state.goalData = goalData
    },
    setGoalProgress(state, goalProgress) {
        state.goalProgress = goalProgress
    },
}

export default {
    namespaced: false,
    state,
    getters,
    actions,
    mutations,
}
